import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, spacing, breakpoints }) => ({
  footerContainer: {
    marginTop: 'auto', // push footer to the bottom
    '& footer': {
      position: 'relative',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  mainContainer: {
    minHeight: '100vh', // instead of height: '100vh'
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  rootText: {
    margin: spacing(3, 15.75, 0, 15.75),
    fontSize: spacing(3),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
  },
  buttonText: {
    fontSize: spacing(2.25),
    fontWeight: spacing(87.5),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: palette.green.dark,
    color: palette.white.main,
    letterHeight: spacing(2.68),
    letterSpacing: '0px',
    padding: spacing(1.25),
    '&:hover': {
      backgroundColor: palette.scorpionGray.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: spacing(3, 33.25, 3, 10.25),
    [breakpoints.down('sm')]: {
      margin: spacing(2),
    },
    [breakpoints.down('md')]: {
      margin: spacing(2),
    },
    [breakpoints.down('lg')]: {
      margin: spacing(3),
    },
  },
  label: {
    // width: '100%',
    height: '100%',
    margin: spacing(3),
    // display: 'contents',
  },
  radioGroup: {
    display: 'grid',
    gap: spacing(2),
    // margin: spacing(0, 10.25, 0, 10.25),
    [breakpoints.up('xl')]: {
      gridTemplateColumns: 'repeat(5, 458px)',
    },
    [breakpoints.down('xl')]: {
      gridTemplateColumns: 'repeat(3, 458px)',
    },
    [breakpoints.down('lg')]: {
      gridTemplateColumns: 'repeat(3, 458px)',
    },
    [breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 458px)',
    },
    [breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(1, 458px)',
      padding: spacing(2),
    },
    justifyContent: 'center',
    '& .MuiRadio-root': {
      display: 'none',
    },
  },
  templateContainer: {
    // display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    margin: spacing(0),
    display: 'contents',
  },
  subTitle: {
    margin: spacing(1),
    fontSize: spacing(1.75),
    fontWeight: spacing(50),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    // width: '800px',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.75),
      margin: spacing(2),
    },
  },
  congratsTitle: {
    marginBottom: spacing(2),
    marginTop: spacing(2),
    fontSize: spacing(3.125),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    color: '#623293',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
  },
  templateCard: {
    // width: '408px',
    // height: '270px',
    // backgroundColor: '#f5f5f5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional: example shadow
    borderRadius: '8px', // Optional: example rounding for the corners
  },
  logoImage: {
    [breakpoints.down('sm')]: {
      left: spacing(9),
      width: 'auto',
      height: '100px',
      top: spacing(2),
      // padding: spacing(1),
      marginTop: spacing(2),
      display: 'flex',
    },
    [breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  logoContainer: {
    [breakpoints.down('sm')]: {
      // height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    [breakpoints.up('sm')]: {
      display: 'none',
    },
    '@media (max-width:375px)': {
      padding: spacing(2.5),
    },
    '@media (max-width:320px)': {
      padding: spacing(2.5),
    },
  },
  containerX: {
    [breakpoints.up('sm')]: {
      marginTop: '30px',
    },
  },
  snackBar: {
    '& .MuiSnackbarContent-root': {
      backgroundColor: palette.red.light,
    },
  },
}));
